/* Core by Chloe Pilates — product page: Make it a pair, sticky Add to bag */
(function(){
  if (window.__cbcProduct) return; window.__cbcProduct = true;
  const money = (c) => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');

  // adds items to the bag and opens the theme's cart drawer, like the theme's own Add to bag
  async function addToBag(items, activeEl){
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = {items};
    if (cart && typeof cart.getSectionsToRender === 'function'){
      body.sections = cart.getSectionsToRender().map(s => s.id).join(',');
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(activeEl);
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message || 'That pair could not be added.');
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cbc-pair-mini', cartData: data});
    if (data.items && data.items.length && !data.key){ const last = data.items[data.items.length - 1]; data.key = last.key; data.id = last.variant_id; }
    if (cart && typeof cart.renderContents === 'function' && data.sections){ cart.classList.remove('is-empty'); cart.renderContents(data); }
    else window.location = (window.routes && window.routes.cart_url) || '/cart';
  }

  if (!customElements.get('cbc-pair-mini')){
    customElements.define('cbc-pair-mini', class extends HTMLElement {
      connectedCallback(){
        if (this._init) return; this._init = true;
        this.off = parseInt(this.dataset.off, 10) || 0;
        this.opts = Array.from(this.querySelectorAll('.cbpm-opt'));
        this.btn = this.querySelector('[data-add]');
        this.label = this.querySelector('[data-label]'); this.emptyLabel = this.label.textContent;
        this.was = this.querySelector('[data-was]'); this.total = this.querySelector('[data-total]');
        this.err = this.querySelector('[data-error]');
        this.opts.forEach(o => o.addEventListener('click', () => this.choose(o)));
        this.btn.addEventListener('click', () => this.add());
      }
      // the sock on this page: follow the theme's variant picker if there is one
      current(){
        const input = document.querySelector('[id^="MainProduct-"] product-form form input[name="id"]') || document.querySelector('product-form form input[name="id"]');
        const id = (input && input.value) || this.dataset.curVariant;
        return {id: parseInt(id, 10), price: parseInt(this.dataset.curPrice, 10) || 0};
      }
      choose(o){
        const on = o.getAttribute('aria-pressed') !== 'true';
        this.opts.forEach(x => x.setAttribute('aria-pressed', String(x === o && on)));
        this.picked = on ? o : null;
        this.err.hidden = true;
        this.render();
      }
      render(){
        if (!this.picked){
          this.btn.disabled = true; this.label.textContent = this.emptyLabel; this.was.hidden = true; this.total.textContent = ''; return;
        }
        const cur = this.current(), price = parseInt(this.picked.dataset.price, 10) || 0;
        const sum = cur.price + price, deal = Math.max(0, sum - this.off);
        this.btn.disabled = false;
        this.label.textContent = 'Add both to bag';
        this.was.hidden = deal >= sum; this.was.textContent = money(sum);
        this.total.textContent = money(deal);
      }
      async add(){
        if (!this.picked || this.busy) return;
        this.busy = true; this.btn.disabled = true; this.label.textContent = 'Adding…';
        const cur = this.current(), second = parseInt(this.picked.dataset.variant, 10);
        const items = cur.id === second ? [{id: cur.id, quantity: 2}] : [{id: cur.id, quantity: 1}, {id: second, quantity: 1}];
        try {
          await addToBag(items, this.btn);
          this.opts.forEach(x => x.setAttribute('aria-pressed', 'false')); this.picked = null;
        } catch (e) {
          this.err.textContent = e.message || 'Something went wrong. Please try again.'; this.err.hidden = false;
        } finally {
          this.busy = false; this.render();
        }
      }
    });
  }

  if (!customElements.get('cbc-sticky-buy')){
    customElements.define('cbc-sticky-buy', class extends HTMLElement {
      connectedCallback(){
        // fixed bars must sit outside any animated (transformed) section to stay on screen
        if (this.parentElement !== document.body){ document.body.appendChild(this); return; }
        if (this._init) return; this._init = true;
        const main = document.querySelector('[id^="MainProduct-"] product-form .product-form__submit') || document.querySelector('product-form .product-form__submit');
        if (!main){ this.remove(); return; }
        const btn = this.querySelector('.cbsb-btn');
        btn.addEventListener('click', () => { if (!main.disabled) main.click(); });
        const sync = () => { btn.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true'; };
        new MutationObserver(sync).observe(main, {attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
        sync();
        new IntersectionObserver(es => {
          const e = es[0];
          // show only once the main button has scrolled up out of view
          this.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(main);
      }
    });
  }
})();
